import React from 'react'
import ChatParticipantsFormView from '../component/ChatParticipantsFormView'
import ChatParticipantsFormItem from '../blocks/ChatParticipantsFormItem/ChatParticipantsFormItem'
import GlobalSearch from '../../../GlobalSearch/container/GlobalSearch'
import { chatParticipantsSearch } from '../../../../Module/graphQL'
import { authorization } from '../../../../Module/Auth/Auth'

const searchRequestResolver = async searchedString => {
  const authToken = await authorization.getAPIKey()
  const response = await chatParticipantsSearch(authToken, searchedString)
  const result = await response.json()
  const generateUserSuggestion = (label, resultItem) => ({
    item: resultItem,
    label,
  })

  return [
    {
      title: 'Users',
      results: result.data.chatParticipantsSearch.users.map(resultItem =>
        generateUserSuggestion('PARTICIPANT', resultItem),
      ),
    },
    {
      title: 'Cities',
      results: result.data.chatParticipantsSearch.cities.map(resultItem =>
        generateUserSuggestion('CITY', resultItem),
      ),
    },
  ]
}

const ChatParticipantsForm = ({
  setParticipants,
  participants,
  setParticipantsType,
}) => {
  const onItemAdd = suggestion => {
    const { item } = suggestion
    setParticipantsType(item.type)
    setParticipants([...participants, item])
  }

  const onItemDelete = id => {
    const updatedParticipants = participants.filter(
      participant => participant.id != id,
    )
    setParticipants(updatedParticipants)
  }

  const searchRequestHandler = async searchedString => {
    const result = await searchRequestResolver(searchedString)

    if (participants.length > 0) {
      const participantsType = participants[0].type
      const typeData =
        participantsType === 'CITY'
          ? result.filter(section => section.title === 'Cities')
          : result.filter(section => section.title === 'Users')

      const participantsIds = participants.map(({ id }) => id)

      return [
        {
          title: typeData[0].title,
          results: typeData[0].results.filter(data => {
            return !participantsIds.includes(data.item.id)
          }),
        },
      ]
    }
    return result
  }
  return (
    <ChatParticipantsFormView
      onItemAdd={onItemAdd}
      participants={participants}
      searchComponent={
        <GlobalSearch
          style={{ height: '100%', boxShadow: 'unset', width: 200 }}
          placeholder="Search participants..."
          onSuggestionSelected={onItemAdd}
          searchRequestHandler={searchRequestHandler}
        />
      }
    >
      {participants.map(participant => (
        <ChatParticipantsFormItem
          key={participant.id}
          name={participant.name}
          onItemDelete={() => onItemDelete(participant.id)}
        />
      ))}
    </ChatParticipantsFormView>
  )
}

export default ChatParticipantsForm



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatParticipantsForm/container/ChatParticipantsForm.js